import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import MDInput from "components/MDInput";
import Pagination from "@mui/material/Pagination";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  Card,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/system";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";

function MyReadings() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
 
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const [mappingDetails, setMappingDetails] = useState({
    doctorid: "",
    patientid: "",
    ccid: "",
    date: "",
  });

  const [mappingList, setMappingList] = useState([]);
  const navigate = useNavigate();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

  // 🔹 Add Modal
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);



  // 🔹 Delete Modal
  const handleOpenDeleteModal = (id) => {
    setSelectedId(id);
    setDeleteModal(true);
  };
  const handleCloseDeleteModal = () => setDeleteModal(false);

  // 🔹 Input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMappingDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  // 🔹 Delete Mapping
  const handleDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const encryptedData = encryptBody({ id: selectedId }, secretKey);
 
      const response = await axios.post("/api/patientdoctormapping/delete", encryptedData, {
        headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        toast.success(decryptedResponse.message || "Patient Doctor Mapping deleted successfully!");
        setDeleteModal(false);
        fetchMapping();
      }
    } catch (error) {
      toast.error(error.message || "Failed to delete mapping.");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Fetch All Mappings
  const fetchMapping = async (pageNumber = 1) => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get(`/api/devicedata/userid=${userid}`, {
        params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
      
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setMappingList(decryptedData.content || []);
         setCurrentPage(decryptedData.number + 1);
          setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error fetching mappings:", error);
    //   toast.error("Failed to fetch mappings.");
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchMapping();
  // }, []);
 const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    if (searchTerm) {
      setCurrentPage(); 
    }
  }, [searchTerm]);
  
  useEffect(() => {
    if (searchTerm) {
      searchData(currentPage); 
    } else {
      fetchMapping(currentPage);
    }
  }, [searchTerm, currentPage]);
  
const doctorInfo = mappingList.length > 0 ? mappingList[0].patient : null;

  const searchData = async (pageNumber = 1) => {
    setLoading(true);
     
      
        
       try {
         setLoading(true);
         const secretKey = await fetchSecretKey();
         const token = JSON.parse(localStorage.getItem("loginData")).token;
     
         const requestBody = encryptBody(
        {
           userid: doctorInfo.userid,
           
           searchTerm: searchTerm.trim(),
          
         },
         secretKey
        );
   
      const response = await axios.post("/api/patientdoctormapping/searchByPatientNameorDoctorName", 
        requestBody,
        {
            headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response);
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        console.log("Decrypted Search Response:", decryptedData); 
        setMappingList(decryptedData.content || []);
        setCurrentPage(decryptedData.number + 1);
        setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error searching Care Coordinator:", error);
    } finally {
      setLoading(false);
    }
  };
  // Loader Animation
  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MedicalAbstractBackground/>
      {/* Loader */}
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor:"#1A237E",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      )}
 <MDBox mt={1} p={1} display="flex"  alignItems="center" justifyContent="space-between">
  

   <MDTypography variant="h5" sx={{ flex: 1,fontSize: "1.0rem" }}>
    My Readings
  </MDTypography>
     {/* <MDInput
            label="Search Doctor Name"
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ maxWidth: "400px" }}
          /> */}
  </MDBox>

{/* <MDBox mt={-1} p={1} display="flex"  alignItems="center" justifyContent="space-between"> */}
     {/* Doctor Info Section */}


{/*   
    <MDTypography 
      variant="body2"  // smaller font
      sx={{ fontWeight: 600, color: "#333", mb: 0.5 }}
    >
       Patient Name:
  <span style={{ fontWeight: "normal", color: "#555", marginLeft: "4px" }}>
    {doctorInfo
      ? `${doctorInfo.firstname} ${doctorInfo.lastname}`
      : "No Data Available"}
  </span>
    </MDTypography>

    
  


<MDBox sx={{ maxWidth: "400px", width: "100%"}}>
          <MDInput
            label="Search  Name "
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ maxWidth: "400px" }}
          />
        </MDBox>
</MDBox> */}

  {/* <MDBox sx={{ flex: 2, display: "flex", justifyContent: "center" }}>
          <MDInput
            label="Search  Name "
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ maxWidth: "400px" }}
          />
        </MDBox> */}
        {/* <MDBox sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}> */}


          {/* <MDButton
            variant="gradient"
            onClick={() => navigate("/CreateDPmapping")}
            sx={{
              background: "#2e7faeff",
              color: "#fff",
              "&:hover": {
                background: "#2e7faeff",
              },
            }}
          >
            Create Mapping
          </MDButton> */}
       
    {/* </MDBox> */}
   

      {/* </MDBox> */}
     

      {/* Table */}

      <MDBox sx={{ overflowX: "auto", width: "100%" }}>
         <TableContainer component={Paper} sx={{ mt: 3, border: "1px solid #ddd", borderRadius: "8px", boxShadow: "2px 4px 10px rgba(0,0,0,0.1)" }}>
         
    <Table sx={{ tableLayout: "fixed", width: "100%", borderCollapse: "collapse" }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#1A237E" }}>
             {[ "Device Name",  "Data Type", "Datavalue","Recorded At"].map((header, index) => (
                  <TableCell
                    key={index}
                   sx={{
                color: "#fff",
                fontWeight: "600",  
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "7px",
   minWidth:
      index === 0
        ? "280px"     // Device Name
        : index === 1
        ? "220px"     // Data Type
        : index === 2
        ? "350px"     // Datavalue
        : "200px",    // Recorded At

    width:
      index === 0
        ? "300px"
        : index === 1
        ? "250px"
        : index === 2
        ? "400px"
        : "220px",

                whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}

       
  </TableRow>

            <TableBody>
              {mappingList.length > 0 ? (
                mappingList.map((doc, index) => (
                  <TableRow key={index}>
                  
                <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          {doc.devicename || ""}
        </TableCell>
        <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          {doc.datatype || ""}
        </TableCell>
           <TableCell sx={{ border: "1px solid #ddd", padding: "12px" }}>
         <ul style={{ margin: 0, paddingLeft: "16px" }}>
           {doc?.bpSystolic  != null && (
             <li>
               <MDTypography variant="body2">
                 <strong>BP Systolic:</strong>{" "}
                 <span style={{ color: "#1A237E", fontWeight: 700 }}>
                   {doc?.bpSystolic }
                 </span>
               </MDTypography>
             </li>
           )}
       
           {doc?.bpDiastolic  != null && (
             <li>
               <MDTypography variant="body2">
                 <strong>BP Diastolic:</strong>{" "}
                 <span style={{ color: "#1A237E", fontWeight: 700 }}>
                   {doc?.bpDiastolic }
                 </span>
               </MDTypography>
             </li>
           )}
       
           {doc?.bpMean  != null && (
             <li>
               <MDTypography variant="body2">
                 <strong>BP Mean:</strong>{" "}
                 <span style={{ color: "#1A237E", fontWeight: 700 }}>
                   {doc?.bpMean }
                 </span>
               </MDTypography>
             </li>
           )}
       
           {doc?.randomSugar  != null && (
             <li>
               <MDTypography variant="body2">
                 <strong>Random Sugar:</strong>{" "}
                 <span style={{ color: "#1A237E", fontWeight: 700 }}>
                   {doc?.c }
                 </span>
               </MDTypography>
             </li>
           )}
         </ul>
       </TableCell>
          
          <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
          {doc.recordedAt || ""}
        </TableCell>
         
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    align="center"
                    sx={{ border: "1px solid #ddd", padding: "12px", fontStyle: "italic", color: "gray" }}
                  >
                    No Data Available.
                  </TableCell>
                </TableRow>
              )}
              
            </TableBody>
                        </TableHead>

            <Box mt={2} display="flex" justifyContent="center">
                      <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="success"
                         sx={{
                "& .MuiPaginationItem-root": {
                  borderRadius: "4px",
                  color: "#1A237E",          // Text color
                  borderColor: "#1A237E",    // Border color if outlined
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "#1A237E", // Selected background
                  color: "#fff",                 // Selected text color
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "#1A237E", // Slight hover effect
                },
              }}
                      />
                    </Box>
          </Table>
        </TableContainer>
      </MDBox>

      {/* Delete Modal */}
      <Modal open={deleteModal} onClose={handleCloseDeleteModal}>
        <Card sx={{ width: "400px", padding: 4, margin: "auto", mt: 15, textAlign: "center" }}>
          <MDTypography sx={{ mb: 3, fontSize: "16px", fontWeight: "bold" }}>
            Are you sure you want to delete this mapping?
          </MDTypography>
          <MDBox display="flex" justifyContent="space-around">
            <MDButton variant="gradient" onClick={handleDelete} sx={{ background: "red", color: "#fff" }}>
              Delete
            </MDButton>
            <MDButton
              variant="gradient"
              onClick={handleCloseDeleteModal}
              sx={{ background: "#1A237E", color: "#fff" }}
            >
              Cancel
            </MDButton>
          </MDBox>
        </Card>
      </Modal>
    </DashboardLayout>
  );
}

export default MyReadings;
